/* eslint-disable sort-keys */ export default {
    px: '1px',
    0.25: '0.125rem',
    0.5: '0.25rem',
    1: '0.5rem',
    1.5: '0.75rem',
    2: '1rem',
    2.5: '1.25rem',
    3: '1.5rem',
    4: '2rem',
    5: '2.5rem',
    6: '3rem',
    7: '3.5rem',
    8: '4rem',
    9: '4.5rem',
    10: '5rem',
    11: '5.5rem',
    12: '6rem',
    15: '7.5rem'
}; /* eslint-enable sort-keys */ 

//# sourceMappingURL=space.js.map